/** Tracks scrolling and animation activity until navigation has settled, including held pan gestures. */
export function observePlanNavigation(setActive: (active: boolean) => void) {
  let timer = 0;
  let active = false;
  const pointers = new Set<number>();

  const settle = () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      if (pointers.size) return;
      active = false;
      setActive(false);
    }, 150);
  };
  const activity = () => {
    if (!active) {
      active = true;
      setActive(true);
    }
    settle();
  };
  const onScroll = (event: Event) => {
    if (event.target instanceof Element && event.target.matches(".C1_drawingArea, #pageScroller, #pageOuter")) activity();
  };
  const onPointerDown = (event: PointerEvent) => { pointers.add(event.pointerId); };
  const onPointerUp = (event: PointerEvent) => {
    pointers.delete(event.pointerId);
    if (active) settle();
  };
  const onBlur = () => {
    pointers.clear();
    if (active) settle();
  };
  window.addEventListener("scroll", onScroll, true);
  window.addEventListener("pointerdown", onPointerDown, true);
  window.addEventListener("pointerup", onPointerUp, true);
  window.addEventListener("pointercancel", onPointerUp, true);
  window.addEventListener("blur", onBlur);
  return {
    activity,
    dispose() {
      window.clearTimeout(timer);
      window.removeEventListener("scroll", onScroll, true);
      window.removeEventListener("pointerdown", onPointerDown, true);
      window.removeEventListener("pointerup", onPointerUp, true);
      window.removeEventListener("pointercancel", onPointerUp, true);
      window.removeEventListener("blur", onBlur);
      setActive(false);
    },
  };
}
